import type { EduCoursesTariffsCollectionState } from './edu-courses-tariffs.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY, eduCoursesTariffsAdapter } from './edu-courses-tariffs.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollection } = eduCoursesTariffsAdapter.getSelectors();

export const selectEduCoursesTariffsState = createSelector(
    collectionsState,
    (state: CollectionsState): EduCoursesTariffsCollectionState => state[EDU_COURSES_TARIFFS_COLLECTION_FEATURE_KEY]
);

export const selectEduCoursesTariffs = createSelector(selectEduCoursesTariffsState, selectCollection);
